import { StrictMode } from "react"

import angular from "angular"
import { createRoot } from "react-dom/client"

import { StudentAssignmentsList } from "./StudentAssignmentsList"
import { StudentAssignmentsStore } from "./store/StudentAssignmentsStore"
import { StudentAssignmentsPresenter } from "./presenter/StudentAssignmentsPresenter"
import { AngularNavigationAPI } from "./external/NavigationAPI"
import StudentCacheService from "../../app/services/student-cache/student-cache.service"
import StorageService from "../../app/services/storage/storage.service"
import NotificationService from "../../app/services/notification/notification.service"
import AssignmentWorkService from "../../app/services/assignment-work/assignment-work.service"
import FeedbackService from "../../app/services/feedback/feedback.service"
import AuthService from "../../app/services/auth/auth.service"

StudentAssignmentsListDirective.$inject = ["$injector"]

export function StudentAssignmentsListDirective(
  $injector: angular.auto.IInjectorService,
): angular.IDirective {
  return {
    restrict: "E",
    link: function (scope, element) {
      const $state = $injector.get("$state") as angular.ui.IStateService
      const studentCacheService = $injector.get(
        "StudentCacheService",
      ) as StudentCacheService
      const storageService = $injector.get("StorageService") as StorageService
      const notificationService = $injector.get(
        "NotificationService",
      ) as NotificationService
      const assignmentWorkService = $injector.get(
        "AssignmentWorkService",
      ) as AssignmentWorkService
      const feedbackService = $injector.get(
        "FeedbackService",
      ) as FeedbackService
      const authService = $injector.get("AuthService") as AuthService

      const store = new StudentAssignmentsStore(
        studentCacheService,
        storageService,
        notificationService,
        assignmentWorkService,
        feedbackService,
        authService,
      )

      const navigationAPI = new AngularNavigationAPI($state)

      const presenter = new StudentAssignmentsPresenter(store, navigationAPI)

      const root = createRoot(element[0])

      root.render(
        <StrictMode>
          <StudentAssignmentsList presenter={presenter} />
        </StrictMode>,
      )

      scope.$on("$destroy", () => {
        presenter.destroy()
        store.destroy()
        root.unmount()
      })
    },
  }
}
